import React, { useState } from "react";
import { RegularButton, RoundButton } from "components/Button";
import { ReactComponent as BookingIcon } from "assets/icons/booking.svg";
import { ReactComponent as LocationMarkerIcon } from "assets/icons/location-marker.svg";
import BookingConfigsList from "./BookingConfigsList";
import LocationsList from "./LocationsList";

type SelectedIcon = "booking" | "locationMarker";

const DetailSelector = () => {
  const [selected, setSelected] = useState<SelectedIcon>("booking");
  // Owned here because the button that opens it lives in this header, not in the
  // list component below.
  const [createOpen, setCreateOpen] = useState(false);

  return (
    <div className="p-4">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
        <div className="flex flex-wrap gap-4">
          <RoundButton
            Icon={BookingIcon}
            size="large"
            iconLineType="fill"
            selected={selected === "booking"}
            onClick={() => setSelected("booking")}
          />

          <RoundButton
            Icon={LocationMarkerIcon}
            size="large"
            iconLineType="fill"
            selected={selected === "locationMarker"}
            onClick={() => setSelected("locationMarker")}
          />
        </div>
        <div className="flex flex-wrap gap-2">
          <RegularButton
            color="Secondary"
            onClick={() => setCreateOpen(true)}
            disabled={selected !== "booking"}
          >
            <span>Add Booking Configuration</span>
          </RegularButton>
        </div>
      </div>

      {selected === "booking" ? (
        <BookingConfigsList
          createOpen={createOpen}
          onCreateClose={() => setCreateOpen(false)}
        />
      ) : (
        <LocationsList />
      )}
    </div>
  );
};

export default DetailSelector;
